import { render, staticRenderFns } from "./DoctorsPerSector.vue?vue&type=template&id=19074243&"
import script from "./DoctorsPerSector.vue?vue&type=script&lang=js&"
export * from "./DoctorsPerSector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports